export function flatToNested(flat, schema, extraLevels = {}) {
  const out = {};

  // 建立 key → level 的對照表
  const keyLevelMap = schema.fields.reduce(
    (acc, f) => {
      acc[f.key] = f.level;
      return acc;
    },
    { ...extraLevels }
  ); // 把特例直接混進去

  // 把 flat 的每個 key 塞進去對應 level
  for (const [key, value] of Object.entries(flat)) {
    const level = keyLevelMap[key];
    if (level === undefined) continue; // schema 裡沒有就跳過

    const L = String(level);
    (out[L] ||= []).push({ [key]: value });
  }

  return out;
}
